if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.submitButton.disabled) {
          this.setNotifyButton();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.classList.contains('notify-button')) {
          this.openNotifyDrawer();
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          );

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(
          variantId,
          quantity
        );

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              this.dispatchCartErrorEvent(
                response.description || response.message,
                'INVALID'
              );

              linesUpdateDeferred?.reject(
                new Error(response.description || response.message)
              );

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.setNotifyButton();

              this.error = true;
              return;
            }

            if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker(
              'add:wait-for-subscribers'
            );

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(response);
                }
              );
            }
          })
          .catch(e => {
            console.error(e);

            this.dispatchCartErrorEvent(
              e.message || 'Network error',
              'SERVICE_UNAVAILABLE'
            );

            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      openNotifyDrawer() {
        const drawer = document.querySelector('.notify-drawer');

        if (!drawer) return;

        const formId = this.form.id;

        const selectedSize = document.querySelector(
          `input[data-option-type="size"][form="${CSS.escape(formId)}"]:checked`
        );

        const selectedColor = document.querySelector(
          `input[data-option-type="color"][form="${CSS.escape(formId)}"]:checked`
        );

        const size = selectedSize?.value || '';
        const color = selectedColor?.value || '';
        const variantId = this.variantIdInput?.value || '';

        drawer.dataset.size = size;
        drawer.dataset.color = color;
        drawer.dataset.variantId = variantId;

        const sizeOutput = drawer.querySelector('[data-notify-size]');

        if (sizeOutput) {
          sizeOutput.textContent = size;
        }

        drawer.classList.add('active');
        this.closest('quick-add-modal')?.hide(true);
      }

      setNotifyButton() {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.add('notify-button');

        if (this.submitButtonText) {
          this.submitButtonText.classList.remove('hidden');
          this.submitButtonText.textContent = 'Notificarme';
        }

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

        if (soldOutMessage) {
          soldOutMessage.classList.add('hidden');
        }
      }

      setAddToCartButton() {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('notify-button');

        if (this.submitButtonText) {
          this.submitButtonText.classList.remove('hidden');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

        if (soldOutMessage) {
          soldOutMessage.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        const submitButton = this.querySelector('[type="submit"]');
        const submitButtonText = submitButton?.querySelector('span');

        if (!submitButton || !submitButtonText) return;

        if (!submitButton.dataset.originalText) {
          submitButton.dataset.originalText = submitButtonText.textContent.trim();
        }

        if (errorMessage) {
          submitButtonText.textContent = 'Cantidad máxima alcanzada';
          submitButton.classList.add('product-form__submit--error');
          submitButton.setAttribute('aria-disabled', 'true');
        } else {
          submitButton.classList.remove('product-form__submit--error');
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.setNotifyButton();

          if (text) {
            this.submitButton.dataset.disabledText = text;
          }

          return;
        }

        this.setAddToCartButton();
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [
              {
                merchandiseId: variantId,
                quantity,
              },
            ],
            promise: deferred.promise,
          })
        );

        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;

        const { CartLinesUpdateEvent } = window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise =
          typeof CartItems !== 'undefined'
            ? CartItems.fetchCartData()
            : fetch(`${routes.cart_url}.json`).then(response => response.json());

        pendingCartDataPromise
          .then(cart => {
            if (!cart?.currency) {
              return deferred.reject(
                new Error('Missing currency in cart response')
              );
            }

            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            });
          })
          .catch(e => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};

        if (!CartErrorEvent) return;

        this.dispatchEvent(
          new CartErrorEvent({
            error: message,
            code,
          })
        );
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}